import Vue from 'vue'

import wAutocomplete from './wAutocomplete'
import wB2Select2 from './wB2Select2'
import wB2mSelect2 from './wB2mSelect2'
import wBelongsto from './wBelongsto'
import wCheckbox from './wCheckbox'
import wCustom from './wCustom'
import wDatePicker from './wDatePicker'
import wDateRangePicker from './wDateRangePicker'
import wDatetimeRangePicker from './wDatetimeRangePicker'
import wDateSelect from './wDateSelect'
import wDateText from './wDateText'
import wHasmany from './wHasmany'
import wHasmanyListed from './wHasmanyListed'
import wHidden from './wHidden'
import wImage from './wImage'
import wInput from './wInput'
import wInputHelped from './wInputHelped'
import wMap from './wMap'
import wMapView from './wMapView'
import wMultiSelect from './wMultiSelect'
import wPreview from './wPreview'
import wRadio from './wRadio'
import wSelect from './wSelect'
import wStatus from './wStatus'
import wSwap from './wSwap'
import wText from './wText'
import wTextarea from './wTextarea'
import wTexthtml from './wTexthtml'
import wUpload from './wUpload'
import wUploadAjax from './wUploadAjax'

Vue.component('w-autocomplete', wAutocomplete)
Vue.component('w-b2-select2', wB2Select2)
Vue.component('w-b2m-select2', wB2mSelect2)
Vue.component('w-belongsto', wBelongsto)
Vue.component('w-checkbox', wCheckbox)
Vue.component('w-custom', wCustom)
Vue.component('w-date-picker', wDatePicker)
Vue.component('w-date-range-picker', wDateRangePicker)
Vue.component('w-datetime-range-picker', wDatetimeRangePicker)
Vue.component('w-date-select', wDateSelect)
Vue.component('w-date-text', wDateText)
Vue.component('w-hasmany', wHasmany)
Vue.component('w-hasmany-listed', wHasmanyListed)
Vue.component('w-hidden', wHidden)
Vue.component('w-image', wImage)
Vue.component('w-input', wInput)
Vue.component('w-input-helped', wInputHelped)
Vue.component('w-map', wMap)
Vue.component('w-map-view', wMapView)
Vue.component('w-multi-select', wMultiSelect)
Vue.component('w-preview', wPreview)
Vue.component('w-radio', wRadio)
Vue.component('w-select', wSelect)
Vue.component('w-status', wStatus)
Vue.component('w-swap', wSwap)
Vue.component('w-text', wText)
Vue.component('w-textarea', wTextarea)
Vue.component('w-texthtml', wTexthtml)
Vue.component('w-upload', wUpload)
Vue.component('w-upload-ajax', wUploadAjax)
